import { createAction, props } from '@ngrx/store';
import { InvoiceDiscrepancies, Invoices } from '../../data/interfaces';

export const loadInvoices = createAction(
    '[Invoice] Load Invoices',
    props<{
        filter?: {
            page?: number;
            pageSize?: number;
            searchString?: string;
            carrier?: string;
            shipper?: string;
            fromDate?: string;
            toDate?: string;
        }
    }>()
);

export const loadInvoicesSuccess = createAction(
    '[Invoice] Load Invoices Success',
    props<{
        invoices: {
            currentPage: number;
            invoices: Invoices[];
            totalItems: number;
            totalPages: number;
        }
    }>()
);

export const loadInvoicesFailure = createAction(
    '[Invoice] Load Invoices Failure',
    props<{ error: string }>()
);

export const loadDiscrepancies = createAction('[Invoice] Load Discrepancies', props<{ filter: any }>());

export const loadDiscrepanciesSuccess = createAction(
    '[Invoice] Load Discrepancies Success',
    props<{
        discrepancies: {
            currentPage: number;
            discrepancies: InvoiceDiscrepancies[];
            totalItems: number;
            totalPages: number;
        }
    }>()
);

export const loadDiscrepanciesFailure = createAction(
    '[Invoice] Load Discrepancies Failure',
    props<{ error: string }>()
);

export const addDiscrepancy = createAction(
    '[Invoice] Add Discrepancy',
    props<{ shipmentId: string, owner?: string }>()
);

export const addDiscrepancySuccess = createAction(
    '[Invoice] Add Discrepancy Success',
    props<{ discrepancy: InvoiceDiscrepancies }>()
);

export const addDiscrepancyFailure = createAction(
    '[Invoice] Add Discrepancy Failure',
    props<{ error: string }>()
);

export const updateDiscrepancy = createAction(
    '[Invoice] Update Discrepancy',
    props<{ id: string, discrepancy: InvoiceDiscrepancies }>()
);

export const updateDiscrepancySuccess = createAction(
    '[Invoice] Update Discrepancy Success',
    props<{ discrepancy: InvoiceDiscrepancies }>()
);

export const updateDiscrepancyFailure = createAction(
    '[Invoice] Update Discrepancy Failure',
    props<{ error: string }>()
);

export const deleteDiscrepancy = createAction(
    '[Invoice] Delete Discrepancy',
    props<{ id: string }>()
);

export const deleteDiscrepancySuccess = createAction(
    '[Invoice] Delete Discrepancy Success',
    props<{ id: string }>()
);

export const deleteDiscrepancyFailure = createAction(
    '[Invoice] Delete Discrepancy Failure',
    props<{ error: string }>()
);

export const bulkDeleteDiscrepancies = createAction(
    '[Invoice] Bulk Delete Discrepancies',
    props<{ ids: string[] }>()
);

export const bulkDeleteDiscrepanciesSuccess = createAction(
    '[Invoice] Bulk Delete Discrepancies Success',
    props<{ ids: string[] }>()
);

export const bulkDeleteDiscrepanciesFailure = createAction(
    '[Invoice] Bulk Delete Discrepancies Failure',
    props<{ error: string }>()
);

export const bulkUpdateDiscrepancyStatus = createAction(
    '[Invoice] Bulk Update Discrepancy Status',
    props<{ ids: string[]; status: string }>()
);

export const bulkUpdateDiscrepancyStatusSuccess = createAction(
    '[Invoice] Bulk Update Discrepancy Status Success',
    props<{ ids: string[]; status: string }>()
);

export const bulkUpdateDiscrepancyStatusFailure = createAction(
    '[Invoice] Bulk Update Discrepancy Status Failure',
    props<{ error: string }>()
);